import React, { useState } from 'react';

import { ReactEditor, useSlateStatic, useReadOnly } from 'slate-react';

import { ReactComponent as AssistantIcon } from 'assets/images/ask-ai-medium-icon.svg';

import HelptapEditor from '../../helpers';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import { determineBaseProperties } from '../utilities';

import './index.scss';

function AIAssistant(props) {

  const element = props.element;

  const editor = useSlateStatic();
  const readOnly = useReadOnly();

  const elementPath = ReactEditor.findPath(editor, props.element);

  const [rootState, setRootState] = useState({
    instructions: element.properties.instructions
  });

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: [
      nodeControls.ALIGNMENT
    ]
  }, nodeControls);

  function updateInstructions(instructions) {

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        instructions
      };

    });

    HelptapEditor.setAttributes(editor, {
      properties: {
        ...element.properties,
        instructions
      }
    }, elementPath);

  }

  function renderInput() {

    const inputAttributes = {
      className: 'ai-assistant-instructions-input',
      type: 'text',
      placeholder: 'Write your instructions...',
      value: rootState.instructions,
      disabled: readOnly,
      onInput: (event) => updateInstructions(event.target.value)
    };

    return <div className="ai-assistant-main">
      <div className="ai-assistant-details">
        <div className="ai-assistant-picture">
          <AssistantIcon />
        </div>
        <div className="ai-assistant-instructions">
          <input {...inputAttributes} />
        </div>
      </div>
    </div>;

  }

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: '',
      contentEditable: false
    };

    return <div {...attributes}>
      {renderInput()}
      {props.children}
    </div>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default AIAssistant;